<template>
  <div class="row slider">
    <slider v-if="step.css !== 'list'" ref="slider" :key="componentKey" :item-class="step.css" :init-page="startPage" :chevron="true">
      <component :is="(option.type || 'select') + 'Option'"
                 v-for="option in options"
                 :key="option.id"
                 :option="option"
                 :type="step.css"
      />
    </slider>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SelectOption from './selectOption'
import CountOption from './countOption'
export default {
  components: {
    selectOption: SelectOption,
    countOption: CountOption,
    checkOption: SelectOption
  },
  data: () => ({
    page: 1,
    perPage: 6,
    componentKey: 0
  }),
  computed: {
    ...mapGetters({
      currentOptions: 'configurator/currentOptions',
      step: 'configurator/currentStep'
    }),
    startPage () {
      const index = this.currentOptions.findIndex(o => o.selected)
      const page = Math.ceil((index + 1) / this.perPage)
      if (page === 0) {
        return 1
      } else {
        return page
      }
    },
    options () {
      this.$nextTick(() => {
        this.forceRerender()
      })
      return this.currentOptions
    }
  },
  methods: {
    forceRerender () {
      this.componentKey += 1
    }
  }
}
</script>
